export const styles = {
    container: {
        width: '100%',
        height: '100%',
        backgroundColor: '#ececec',
        backgroundImage: 'linear-gradient(to right, #ececec 8%, #ddd 18%, #ececec 40%)',
        backgroundSize: 1000,
        borderRadius: 'inherit',
        animation: {
            name: 'placeholder-shimmer',
            duration: '1.4s',
            timingFunction: 'linear',
            iterationCount: 'infinite',
            fillMode: 'forwards',
        }
    },
    '@keyframes placeholder-shimmer': {
        '0%': 'background-position: -500px 0',
        '100%': 'background-position: 500px 0'
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
